import { useState } from "react";
import { useIntl } from "react-intl";

// The picture block of a Share detail page: one large image, and once there are several a strip of
// thumbnails that swaps it. The first entry leads, so callers put the mainImage first. Draws nothing
// without an image. Used by a post's detail page and by both listing detail pages.
export function ImageGallery({
  images,
  alt,
  heroId,
  className = "",
}: {
  /** `data:` sources, the lead image first. */
  images: readonly string[];
  /** Describes the large image; the thumbnails are named by position. */
  alt: string;
  /** Testanker; unbesetzt, wo kein Test hingreift. */
  heroId?: string;
  /** Layout only (margins and width constraints). */
  className?: string;
}) {
  const intl = useIntl();
  const [activeIdx, setActiveIdx] = useState(0);
  if (images.length === 0) return null;
  // A list that shrank under a picked thumbnail falls back to its last image instead of to nothing.
  const active = Math.min(activeIdx, images.length - 1);

  return (
    <div className={className}>
      <div className="overflow-hidden rounded-md bg-ink/[0.06] ring-1 ring-ink/5">
        <img id={heroId} src={images[active]} alt={alt} className="aspect-[16/9] w-full object-cover" />
      </div>
      {images.length > 1 ? (
        <div className="mt-3 flex gap-2 overflow-x-auto pb-1">
          {images.map((src, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setActiveIdx(i)}
              title={intl.formatMessage(
                { id: "share.itemDetail.imageN", defaultMessage: "Image {n}" },
                { n: i + 1 },
              )}
              className={`shrink-0 overflow-hidden rounded-md ring-1 transition ${
                i === active ? "ring-accent-decoration" : "ring-ink/10 hover:ring-accent-decoration/40"
              }`}
            >
              <img src={src} alt="" className="h-16 w-24 object-cover" />
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
